export const MANAGEMENT_SYSTEM = {
    Solteq: 0,
    Automaster: 1,
    Futuresoft: 2,
    SolteqAPI: 3
};